import { Box, Button, Grid, styled, Typography } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetchAllDivisi from "../../../../api/effects/queries/Divisi/useFetchAllDivisi";
import useFetchAllPendidikan from "../../../../api/effects/queries/Pendidikan/useFetchAllPendidikan";
import { DivisiResponse } from "../../../../models/Divisi";
import { PendidikanResponse } from "../../../../models/Pendidikan";
import { CustomToolbar } from "../../HeaderHR";
import PendidikanModal from "./PendidikanModal";

const BoxTable = styled(Box)({
  maxWidth: "1280px",
  height: "70vh",
  width: "100%",
});

export default function PendidikanTable() {
  const columns: GridColDef[] = [
    {
      field: "PENDIDIKAN_ID",
      headerName: "Pendidikan ID",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    { field: "PENDIDIKAN", headerName: "Pendidikan", flex: 1 },
    {
      field: "IS_ACTIVE",
      headerName: "Is Active",
      type: "boolean",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          handleOpenModalEdit(params.row.PENDIDIKAN_ID);
        };
        return <Button onClick={onClick}>Edit</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
  ];
  const { data: allPendidikanData } = useFetchAllPendidikan();

  const [data, setData] = useState<PendidikanResponse[]>();

  useEffect(() => {
    if (allPendidikanData !== undefined) {
      setData(allPendidikanData);
    }
  }, [allPendidikanData]);

  const [IDState, setIDState] = useState(-1);
  const [modalState, setModalState] = useState(false);

  const handleOpenModalAdd = () => {
    setIDState(-1);
    setModalState(!modalState);
  };
  const handleOpenModalEdit = (e: number) => {
    setIDState(e);
    setModalState(!modalState);
  };

  const handleCloseModal = () => {
    setModalState(!modalState);
  };

  return (
    <>
      <PendidikanModal
        open={modalState}
        handleClose={handleCloseModal}
        ID={IDState}
      />
      <Grid
        container
        justifyContent="flex-start"
        sx={{
          maxWidth: "1280px",
          paddingBottom: "1vh",
        }}
      >
        <Typography variant="h4">Tabel Pendidikan</Typography>
      </Grid>
      <BoxTable>
        {data !== undefined ? (
          <DataGrid
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(data) => data.PENDIDIKAN_ID}
            disableColumnMenu
            components={{ Toolbar: CustomToolbar }}
          />
        ) : (
          <div />
        )}
      </BoxTable>
      <Grid
        container
        justifyContent="flex-end"
        sx={{
          maxWidth: "1280px",
          paddingTop: "2vh",
        }}
      >
        <Button variant="contained" onClick={handleOpenModalAdd}>
          Tambah Pendidikan
        </Button>
      </Grid>
    </>
  );
}
